import React from 'react';
import PropTypes from 'prop-types';
import { UUID } from '../util';

const CrumbLink = ({ isLast, crumb }) => {
  return !isLast
    ? <a href={crumb.url} className="list__link breadcrumb__link">{crumb.label}</a> : crumb.label;
};

/** data driven breadcrumb
 * @group Components
 */

const Breadcrumb = ({ breadCrumbs }) => {
  return (
    <div id="breadcrumb">
      <ul id="headerCrumb" className="list list--type-plain breadcrumb__header">
        <li className="list__item--type-inline breadcrumb__item">
          <a
            href="/"
            className="breadcrumb-home list__link breadcrumb__link"
          >Home
          </a>
        </li>
        {breadCrumbs.map((crumb, i) => (
          <li key={UUID()} className="list__item--type-inline breadcrumb__item"><CrumbLink
            isLast={(i === breadCrumbs.length - 1)}
            crumb={crumb}
          />
          </li>
        ))}
      </ul>
      <div className="clear">&nbsp;</div>
    </div>
  );
};

CrumbLink.propTypes = {
  crumb: PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.string
  }),
  isLast: PropTypes.bool.isRequired
};

CrumbLink.defaultProps = {
  crumb: {}
};

Breadcrumb.propTypes = {
  breadCrumbs: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.string
  })).isRequired
};

export default Breadcrumb;
